import packageJson from '../../package.json';
import {isKeptOnSignOut} from "./ui-prefs";
export const setStorage=(key, value)=>{
    localStorage.setItem(key, JSON.stringify(value));
    window.dispatchEvent(new Event("storage"));
};

export const setUser=(data, key=packageJson['client-key'])=>{
    localStorage.setItem(key, JSON.stringify(data));
    window.dispatchEvent(new Event("storage"));
};

export const setSiteConfigs=(data)=>{
    localStorage.setItem("site-configs", JSON.stringify(data));
    window.dispatchEvent(new Event("storage"));
};

// signing out clears the session and data, but keeps the per-user display preferences (ui-prefs.js: a minimized dock
// stays minimized when the same person signs in again)
export const clear=()=>{
    const kept = [];
    for (let index = 0; index < localStorage.length; index += 1) {
        const key = localStorage.key(index);
        if (isKeptOnSignOut(key)) kept.push([key, localStorage.getItem(key)]);
    }
    localStorage.clear();
    kept.forEach(([key, value]) => localStorage.setItem(key, value));
    window.dispatchEvent(new Event("storage"));
};

export const getStorage=(key)=>{
    return JSON.parse(localStorage.getItem(key));
};

export const getUser=(key=packageJson['client-key'])=>{
    return JSON.parse(localStorage.getItem(key));
};

export const getSiteConfigs=()=>{
    return JSON.parse(localStorage.getItem("site-configs"));
};

export const onStorageUpdated=(f)=>{
    window.addEventListener('storage', f);
}
